import { render, staticRenderFns } from "./request_letter.vue?vue&type=template&id=2d433f16&"
import script from "./request_letter.vue?vue&type=script&lang=js&"
export * from "./request_letter.vue?vue&type=script&lang=js&"
import style0 from "./request_letter.vue?vue&type=style&index=0&id=2d433f16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports